import { render, staticRenderFns } from "./BoardPropxyView.vue?vue&type=template&id=e9b7222a"
import script from "./BoardPropxyView.ts?vue&type=script&lang=ts&external"
export * from "./BoardPropxyView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports